var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaneTakeoff = function SvgPlaneTakeoff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m6.98 7.373 3.318 1.32a.42.42 0 0 0 .331 0l3.522-1.467a.2.2 0 0 0 .093-.075.2.2 0 0 0 0-.225.2.2 0 0 0-.093-.075L9.653 5.067a.8.8 0 0 0-.645 0l-2.028.815a.84.84 0 0 0-.375.3.79.79 0 0 0 0 .899.84.84 0 0 0 .375.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.83 7.153a2 2 0 0 0-.462-.662 2.1 2.1 0 0 0-.692-.438 2.14 2.14 0 0 0-1.62 0L7.811 10.746a.42.42 0 0 1-.356 0l-2.02-.978a.88.88 0 0 0-.713 0l-2.206.897a.85.85 0 0 0-.326.234.783.783 0 0 0-.156.747.8.8 0 0 0 .21.339l3.183 3.055c.112.12.26.205.423.244s.335.03.493-.024l4.803-1.874a.23.23 0 0 1 .229.04.213.213 0 0 1 .05.22L9.73 17.9a.8.8 0 0 0-.028.478.8.8 0 0 0 .257.41.87.87 0 0 0 .95.122l2.3-1.1a.83.83 0 0 0 .382-.366l3.182-6.111a.38.38 0 0 1 .229-.196l3.682-1.32c.259-.102.493-.251.691-.44.198-.19.355-.414.462-.662a1.97 1.97 0 0 0 .001-1.562z"
  })));
};
export default SvgPlaneTakeoff;